import React, { useState } from 'react';
import { getConsent, setConsent } from '../lib/analytics';

const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !getConsent());
  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-black text-white border-t border-white/20"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-sm text-white/80" data-testid="cookie-banner-message">
          This site uses cookies for anonymous analytics to understand how visitors use it. No personal details are shared.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-decline-btn"
            onClick={() => choose('denied')}
            className="px-5 py-2 text-sm border border-white/40 hover:bg-white/10 transition-colors"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={() => choose('granted')}
            className="px-5 py-2 text-sm bg-white text-black hover:bg-white/85 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
